import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import home from '../views/home.vue'
import introduce from '../views/introduce.vue'
import map from '../views/map.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'map',
    component: map
  },
  {
    path: '/introduce',
    name: 'introduce',
    component: introduce
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
 
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
